var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blocProduit" }, [
    _vm.isNewFormula
      ? _c("span", { staticClass: "badge badge-primary" }, [
          _vm._v("Nouvelle formule")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isNew
      ? _c("span", { staticClass: "badge badge-primary" }, [
          _vm._v("Nouveauté")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.bestSales
      ? _c("span", { staticClass: "badge badge-primary" }, [
          _vm._v("Meilleures ventes")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.provenSatisfaction
      ? _c("span", { staticClass: "badge badge-primary" }, [
          _vm._v("Satisfaction prouvée")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.provenEffectiveness
      ? _c("span", { staticClass: "badge badge-primary" }, [
          _vm._v("Efficacité prouvée")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isRecommended
      ? _c("span", { staticClass: "badge badge-primary" }, [
          _vm._v("Recommandé pour vous")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "vignette",
        attrs: { href: _vm.url },
        on: { click: _vm.link }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: _vm.cardImage, alt: _vm.title }
        })
      ]
    ),
    _vm._v(" "),
    _c("h2", [
      _c("a", { attrs: { href: _vm.url }, on: { click: _vm.link } }, [
        _vm._v(_vm._s(_vm.title) + " "),
        _c("span", [_vm._v(_vm._s(_vm.subtitle))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "zoneActions" }, [
      _c("div", {
        staticClass: "reviews skeepers_product__stars",
        attrs: { "data-product-id": _vm.productId }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "prix" }, [
        _vm._v(
          "\n                à partir de " +
            _vm._s(_vm._f("moneyFormat")(_vm.lowestPrice)) +
            "\n                "
        ),
        _vm.lowestBasePrice != _vm.lowestPrice
          ? _c("del", [
              _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.lowestBasePrice)))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-default btnChoiceType",
          attrs: {
            "data-toggle": "collapse",
            href: "#layerChoiceType" + _vm.id,
            role: "button",
            "aria-expanded": "false",
            "aria-controls": "layerChoiceType" + _vm.id
          },
          on: {
            click: function($event) {
              _vm.closeOther()
            }
          }
        },
        [_vm._v("Choisir une quantité")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse layerChoiceType",
          attrs: { id: "layerChoiceType" + _vm.id }
        },
        [
          _c(
            "div",
            { staticClass: "horizontalChoice" },
            _vm._l(_vm.references, function(reference, index) {
              return false == reference.direct_order
                ? _c("ponroy-product-reference-card", {
                    key: reference.id,
                    attrs: {
                      value: reference.id,
                      reference: reference,
                      "radio-name": "radio-name-" + _vm.id
                    },
                    model: {
                      value: _vm.orderable.id,
                      callback: function($$v) {
                        _vm.$set(_vm.orderable, "id", $$v)
                      },
                      expression: "orderable.id"
                    }
                  })
                : _vm._e()
            })
          )
        ]
      ),
      _vm._v(" "),
      _vm.available
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary hvr-grow",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.update()
                }
              }
            },
            [_vm._v("Ajouter au panier")]
          )
        : _c("span", { staticClass: "btn btn-primary btn-indispo" }, [
            _vm._v("Indisponible")
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ae661db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae661db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/ProductCard.vue
// module id = 515
// module chunks = 1